import type { SamplesOrderLocationModalState } from '../SamplesOrders.types'

export const isSamplesOrderLocationModalState = (
  state: unknown,
): state is SamplesOrderLocationModalState => {
  if (!state || typeof state !== 'object') return false

  return 'showModal' in state
}
